export default __webpack_public_path__ + "static/media/environmental_cal.faa1a489.csv";